import Vue from 'vue'
// import {
//   login
// } from '@/api/Wlogin'

const user = {
  state: {
    userId: '',
    status: ''
  },

  mutations: {
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_STATUS: (state, status) => {
      state.userId = status
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
     
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          //设置userId,认证状态  不过期
          
          Vue.$cookies.set('userid', response.data.id, -1)
          Vue.$cookies.set('status', response.data.status, -1)
          Vue.$cookies.set('uuid', response.data.uuid, -1)
          Vue.$cookies.set('mmid', response.data.company_id, -1)
          Vue.$cookies.set('is_admin', response.data.is_admin, -1)
          commit('SET_USER_ID', response.data.id)
          commit('SET_STATUS', response.data.status)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout({
      commit,
      state
    }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        }).finally(() => {
          commit('SET_TOKEN', '')
          //清楚cookie
          Vue.$cookies.remove('ACCESS_TOKEN')
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js